import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Button, CircularProgress, Alert, IconButton, Tooltip } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import RefreshIcon from '@mui/icons-material/Refresh';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const LookerStudioEmbed = ({ embed, refreshKey }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [iframeKey, setIframeKey] = useState(refreshKey || 0);
  
  useEffect(() => {
    // Atualizar a key do iframe quando refreshKey mudar
    setIframeKey(prev => prev + 1);
  }, [refreshKey]);
  
  const handleIframeLoad = () => {
    setLoading(false);
  };
  
  const handleIframeError = () => {
    setLoading(false);
    setError('Erro ao carregar relatório. Verifique se a URL do relatório está correta e se o relatório está configurado para ser incorporado.');
  };
  
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };
  
  const refreshIframe = () => {
    setLoading(true);
    setError(null);
    setIframeKey(prev => prev + 1);
  };
  
  const openInNewTab = () => {
    window.open(embed.embedUrl, '_blank');
  };
  
  return (
    <Paper 
      sx={{ 
        p: 0, 
        mb: 3, 
        position: 'relative', 
        height: isFullscreen ? 'calc(100vh - 120px)' : embed.height || '600px',
        overflow: 'hidden'
      }}
    >
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
        <Typography variant="h6">
          {embed.name}
        </Typography>
        
        <Box>
          <Tooltip title="Atualizar">
            <IconButton onClick={refreshIframe} size="small">
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          
          <Tooltip title="Abrir em nova guia">
            <IconButton onClick={openInNewTab} size="small">
              <OpenInNewIcon />
            </IconButton>
          </Tooltip>
          
          <Tooltip title={isFullscreen ? "Sair da tela cheia" : "Tela cheia"}>
            <IconButton onClick={toggleFullscreen} size="small">
              <FullscreenIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      
      {loading && (
        <Box sx={{ 
          position: 'absolute', 
          top: '50%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Carregando relatório...</Typography>
        </Box>
      )}
      
      {error && (
        <Box sx={{ p: 2 }}>
          <Alert severity="error">{error}</Alert>
        </Box>
      )}
      
      <iframe
        key={iframeKey}
        title={embed.name}
        width={embed.width || "100%"}
        height="100%"
        src={embed.embedUrl}
        frameBorder="0"
        allowFullScreen
        onLoad={handleIframeLoad}
        onError={handleIframeError}
        style={{ display: loading ? 'none' : 'block' }}
      />
    </Paper>
  );
};

export default LookerStudioEmbed;

